// extracted by mini-css-extract-plugin
export default {"paymentSection":"Y0-z"};